import React from 'react';

export default function DealSkeleton() {
  return (
    <div className="relative rounded-xl shadow-sm border border-gray-100 bg-white flex flex-col h-full overflow-hidden">
      
      {/* Ghost Image Area - Matches your aspect-square fix perfectly */}
      <div className="relative w-full aspect-square bg-gray-200 animate-pulse rounded-t-xl" />

      {/* Ghost Content Area */}
      <div className="p-4 flex-1 flex flex-col">
        
        {/* Ghost Vote Bar & Store Tag */}
        <div className="flex items-center justify-between mb-2">
            <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
            <div className="h-6 w-16 bg-gray-100 rounded-full animate-pulse" />
        </div>

        {/* Ghost Title - Matches the min-h-[3rem] geometry */}
        <div className="min-h-[3rem] w-full flex flex-col gap-2 mb-1">
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse" />
        </div>

        {/* Ghost Metadata (Time ago, etc.) */}
        <div className="flex items-center justify-between mt-2 mb-2">
            <div className="h-4 w-12 bg-gray-100 rounded animate-pulse" />
            <div className="h-4 w-20 bg-gray-100 rounded animate-pulse" />
        </div>

        {/* Ghost Footer (Price & Buttons) */}
        <div className="mt-auto pt-3 flex items-end justify-between border-t border-gray-100/50">
          <div className="h-8 w-24 bg-gray-200 rounded animate-pulse" />
          
          <div className="flex gap-2">
            <div className="h-9 w-9 bg-gray-100 rounded-full animate-pulse" />
            <div className="h-9 w-9 bg-gray-100 rounded-full animate-pulse" />
            <div className="h-9 w-24 bg-yellow-200 rounded-lg animate-pulse" />
          </div>
        </div>

      </div>
    </div>
  );
}